import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsNewBlackjackMakeDecision implements ICommand
{

	public GameID : number = 0;
	public Decision : number = 0;
	public Seat : number = 0;
	public Type : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readUint53();
		this.Decision = ba.readUint32();
		this.Seat = ba.readUint32();
		this.Type = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		ba.writeUint32(this.Decision);
		ba.writeUint32(this.Seat);
		ba.writeUint32(this.Type);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsNewBlackjackMakeDecision();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'Decision(D)='+this.Decision+' ';
		str += 'Seat(D)='+this.Seat+' ';
		str += 'Type(D)='+this.Type+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55105;
	}

	public getCmdName() : string
	{
		return 'PsNewBlackjackMakeDecision';
	}

}
